<div class="calendar-container">
  <div class="event-container-screen-content">
    <div class="search-container">
      <app-search-bar
        actionText="Pesquisar"
        placeholder="Pesquise por eventos"
        (search)="filter($event)"
      ></app-search-bar>
      <div>
        <app-icon-text-button
          *appIfRoles="profilesElegibleToManageEvents"
          text="Criar novo evento"
          imagePath="../../../../assets/icons/calendar.svg"
          route="event"
        >
        </app-icon-text-button>
      </div>
    </div>
    <div class="filter-pagination" *ngIf="page">
      <div class="filters" *ngIf="years">
        <app-year-select
          #yearSelectId
          [idSchool]="idSchool"
          [selectedYear]="selectedYear"
          (selectEvent)="changeYear($event)"
        ></app-year-select>
        <div class="classroom-filter">
          <app-classroom-select
            [initialIds]="selectedIdsClassrooms"
            [year]="selectedYear"
            (selectEvent)="handleSelectClassroom($event)"
          ></app-classroom-select>
        </div>
        <div class="reset-filter">
          <button class="btn-reset"
            (click)="resetFilters()"
            [disabled]="disableResetFilters"
          >Limpar filtros</button>
        </div>
      </div>
      <div class="paginator">
        <mat-paginator
          hidePageSize="true"
          [pageIndex]="0"
          [length]="page.total"
          [pageSize]="params!.limit"
          aria-label="Select page"
          (page)="handlePageEvent($event)"
        >
        </mat-paginator>
      </div>
    </div>

    <div class="month-filter" *ngIf="!loading">
      <!-- filter component -->
      <app-month-filter
        [selectedMonth]="selectedMonth"
        (changeMonth)="changeMonth($event)"
      ></app-month-filter>
      <!--  -->
    </div>
    <div class="loading-spinner" *ngIf="loading">
      <mat-spinner [diameter]="30"></mat-spinner>
    </div>
    <div *ngIf="events.length == 0 && !loading">
      <div class="container-no-events">
        <img class="no-events" src="assets/images/no-events.svg" />
        <p class="first-line">Ooops!</p>
        <p class="second-line">
          Ainda não existem eventos criados para o mês selecionado.
        </p>
        <p class="third-line" *appIfRoles="profilesElegibleToManageEvents">
          Vamos
          <app-smart-link [customClass]="'custom-link-text'" route="event">
            criar
          </app-smart-link>
          um novo?
        </p>
      </div>
    </div>
    <div class="event-cells-container">
      <div class="event-cells-item" *ngFor="let event of events">
        <app-card-occasion
          [occasionData]="event"
          [typeOccasion]="'EVENTS'"
          [editRoute]="['/event', event.id]"
          [detailsRoute]="['/event', event.id]"
        ></app-card-occasion>
      </div>
    </div>
  </div>
</div>
